<mat-accordion>
  @for (task of compositeTasks; track trackByTask($index, task)) {
    <mat-expansion-panel
      (opened)="openTask(task)"
      >
      <!-- Expansion Header -->
      <mat-expansion-panel-header>
        <mat-panel-title fxLayout="row" fxLayoutAlign="start center">
          <img
            class="task-item-icon"
            [src]="getIconPath(task)"
            />
          <span fxShow fxHide.lt-sm [innerHTML]="task.displayName"></span>
          <span
            fxHide
            fxShow.xs
            [innerHTML]="task.displayName | truncate"
          ></span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <!-- Content -->
      <ng-template matExpansionPanelContent>
        <!-- Expansion Body -->
        @if (task.assetTypeId === assetTypeIds.PERFORM) {
          <div>
            <avenue-viewer [performTask]="task"></avenue-viewer>
          </div>
        }
        @if (task.assetTypeId === assetTypeIds.CUSTOM_ACT) {
          <div
            class="add-scroll"
            >
            <stimulus-activity
              [stimulus]="task"
              [moduleID]="task.assetId"
            ></stimulus-activity>
          </div>
        }
        @if (
          task.assetTypeId === assetTypeIds.EBOOK_ACT ||
          task.assetTypeId === assetTypeIds.EREADER
          ) {
          <div
            >
            <iframe
              [src]="embedUrl"
              onload="this.height=(screen.height * 0.40);this.width=(screen.width * 0.50);"
              frameborder="0"
              allowfullscreen
              allow="microphone *; camera *;"
              title="Resource Activity iframe"
            ></iframe>
          </div>
        }
        @if (task.assetTypeId === assetTypeIds.COG_TUTOR) {
          <div>
            {{ task.description }}
          </div>
        }
      </ng-template>
    </mat-expansion-panel>
  }
</mat-accordion>
